export default __webpack_public_path__ + "static/media/bun-cha-obama.6954c2cc.jpg";